
const state = {
    baseUrl: ''
}

const mutations = {
    setBaseUrl (state, url) {
        state.baseUrl = url
    }
}

export default {
    state,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/global.js